module.exports = __webpack_public_path__ + "img/detail_3x.e598b0d2.png";